import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { Routes as AppRoutes } from "./routes";

import {
  SetPassword
} from './../screens';

const RouterApp = (props) => {
  return (
    <Router>
      <Routes> 
        {/* Web UI */}
        <Route path={AppRoutes.login} element={<SetPassword />} />

        {/* Mobile UI */}
        <Route path={AppRoutes.home} element={<SetPassword />} />
      </Routes>
    </Router>
  );
};

export default RouterApp;
